import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Sidebar({
  hasNoBorder = false,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Container, {
    $hasBorder: !hasNoBorder,
    ...props,
    children
  });
}
const Container = styled.aside.withConfig({
  displayName: "Container",
  componentId: "sc-1pvyynk-0"
})(["overflow-y:auto;box-sizing:border-box;width:272px;height:100%;padding:", " 0;border-right:", ";"], token.spacing5, (props) => props.$hasBorder ? `1px solid ${token.gray100}` : void 0);
export {
  Sidebar
};
//# sourceMappingURL=Sidebar.js.map
